+function ($) {
    /* ======= Owl Carousel ======= */
    $(document).ready(function(){
        // Mobileye Signals Carousel
        $('#contact-controls span').click(function() {
            const country = $(this).data('country');

            // Активный элемент
            $('#contact-controls span').each(function() {
                $(this).removeClass('active');
            });
            $(this).addClass('active');

            // Переключение карты
            $('#contact-maps > div').each(function() {
                $(this).removeClass('active');
            });
            $('#contact-maps .'+country).addClass('active');

            // Переключение контактов
            $('#contact-info > div').each(function() {
                $(this).removeClass('active');
            });
            $('#contact-info .'+country).addClass('active');
        });
    });
}(jQuery);
